import { CheckoutBookingProjection } from "../../../projection/checkoutBooking/checkoutBooking";

const checkoutBooking: CheckoutBookingProjection = {
  id: "e38f6e6d-a729-493b-aa4a-b1b325aa3092",
  checkoutItemIds: ["3bcf99f9-9f5f-43c0-bc01-706549eb84dc"],
  isExpired: false,
};

export { checkoutBooking };
